// UK mobile, as the booking form takes it. Normalise the country-code prefix
// (+44 / 0044 / 44) to the local 0 form FIRST so legitimate international
// formats aren't rejected, then check the 07 + 9 digit shape. The server
// checks the number again with Phonelib (UkMobile, app/models/uk_mobile.rb),
// which also knows which 07 ranges are real.
//
// Exactly 11 digits (07 and nine more): every UK mobile has them. It took 10
// as well, which the server refuses (UkMobile), so "0776655443" passed here
// and was turned away only after the pay press, by the guest sign-up (QA,
// 9 Oct 2026). And "+44 (0)7766 554433", the way many people write their
// own number, was refused here though the server takes it: the (0) after
// the country code is dropped too.
// The digits as the form reads them: spaces, dashes, brackets and dots
// dropped, +44 / 0044 / 44 (and a "(0)" after it) turned into the 0.
//
// Ten digits starting 7 ("7766554433") is a UK mobile without its 0: iOS
// AutoFill puts it in the box like that (replay 01a1497c, 17 Oct 2026, a
// Google ad visitor told "Check your mobile number" for their own number).
// The 0 goes back on. Ten digits starting 0 is still one digit short.
// The server does the same (UkMobile.normalise).
const ukDigits = phone => {
  const d = String(phone || '').replace(/[\s\-().]/g, '').replace(/^(?:\+44|0044|44)0?/, '0')
  return /^7\d{9}$/.test(d) ? `0${d}` : d
}

// Nine of the same digit after 07 (07777777777) passes the range check and
// is nobody (booking-screen-trim, 9 Oct 2026).
const allSame = digits => /^07(\d)\1{8}$/.test(digits)

export const isValidUkMobile = phone => {
  if (!phone) return false
  const cleaned = ukDigits(phone)
  return /^07\d{9}$/.test(cleaned) && !allSame(cleaned)
}

// "07766 554433": how a good mobile reads once the box is left. Anything
// that is not a UK mobile comes back as typed, so nothing is eaten.
export const normaliseUkMobile = phone => {
  if (!isValidUkMobile(phone)) return String(phone || '')
  const d = ukDigits(phone)
  return `${d.slice(0, 5)} ${d.slice(5)}`
}

export const MOBILE_MESSAGES = {
  missing: 'Add a UK mobile number',
  wrong: 'Check your mobile number, e.g. 07766 554433'
}
